import { put, select } from 'redux-saga/effects';
import { selectSelectedLanguage } from '../userData/selectors';
import etrApi from '../utils/etrApi';
import { enqueueErrorSnackbar } from '../notifications/actionWrapper';
import { translate } from '../../utils/translation';
import { returnSnackbarMessage } from '../utils/utils';

export const fetchActivityLogSagaFactory = (actions) => {
  return function* ({ payload }) {
    const lang = yield select(selectSelectedLanguage);
    const page = yield select((state) => state.changeLog.page);
    try {
      const { data } = yield etrApi.get(
        `ppm/unit-project/${payload}/changelog?page=${page}&size=20`,
      );
      if (data) {
        yield put(actions.fetchChangeLogSuccess(data));
      }
    } catch (e) {
      console.error(e);
      yield put(
        enqueueErrorSnackbar(
          returnSnackbarMessage(
            e,
            translate('snackbarMessages.couldNotFetchProjects', lang),
          ),
        ),
      );
      yield put(actions.fetchChangeLogError(e));
    }
  };
};
